export default "__VITE_ASSET__BmGRRW3n__"